import { gql } from 'graphql-request'

export const PRICE_FOR_BUY_BOOK = gql`
  query PriceForBuyBook($bookId: Int!) {
    priceForBuyBook(bookId: $bookId)
  }
`
